<template>
<div>
	<div v-if="!openedApp">
		<p v-if="appsHere.length > 0">Click an app to open it</p>
		<p v-else>There are no apps installed here.</p>
		<div  class="list-group">
			<button type="button" v-for="app in appsHere" class="list-group-item list-group-item-action" v-on:click="openApp(app)">{{app.app_name}}</button>
		</div>
	</div>
	<div v-else>
		<div class="app-bar-controls d-flex justify-content-between align-items-center">
			<h3>{{openedApp.app_name}}</h3>

			<i class="icon-button fa fa-times" v-on:click="openedApp = false"></i>
		</div>
		<iframe id="appIframe" :src="iframeSrc" :style="{height:iframeHeight}"></iframe>
	</div>
</div>
</template>
<script type="text/javascript">
import AppsMixins from "@/mixins/AppsMixins.js"

export default {
	name: "AddonAppTab",
	mixins: [AppsMixins],
	props: ["uiLocation"],
	data() {
		return {
			openedApp: false,
			iframeSrc: ""
		}
	},

	computed: {
		appsHere() {
			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp)
				return this.$store.company.AddonApp.filter(app => app.ui_location == this.uiLocation)

			return []
		},
		iframeHeight() {
			let iframe = document.getElementById("appIframe")

			if (iframe) {
				let height = iframe.contentWindow.document.body.scrollHeight
				if (height)
					return height+"px"
			}

			return "calc(100vh - 145px)";
		}
	},
	methods: {
		openApp(app) {
			let vm = this

			this.openedApp = app
			this.iframeSrc = ""
			this.resolveAddonAppIframeSrc(app).then(src => {
				if (vm.openedApp && vm.openedApp.id == app.id)
					vm.iframeSrc = src
			})
		}
	},
	created() {
		let vm = this

		if (!this.$store.company.AddonApp) {
			this.fetchCompanyData(false, ["CompanySetting", "AddonApp"]).then(() => {
				if (vm.appsHere.length == 1)
					vm.openApp(vm.appsHere[0])
			})
		}
		else if (this.appsHere.length == 1)
			this.openApp(this.appsHere[0])

		vm.addonAppRetryTimer = setTimeout(function () {
			if (vm.$store.company.AddonApp)
				return

			vm.fetchCompanyData(false, ["CompanySetting", "AddonApp"]).then(function () {
				if (vm.appsHere.length == 1)
					vm.openApp(vm.appsHere[0])
			})
		}, 3000)
	},
	destroyed() {
		if (this.addonAppRetryTimer)
			clearTimeout(this.addonAppRetryTimer)
	}
}
</script>

<style type="text/css" scoped>
	.app-bar-controls {
		margin-bottom: 10px;	
	}

	.app-bar-controls h3 {
		margin: 0;
	}

	iframe {
		width: calc(100% + 30px);
		margin: -15px;
		margin-top: 0;
		border: none;
	}
</style>
